export default __webpack_public_path__ + "static/media/foto_segurando_identidade.21185539.png";